import { useRef, useState } from "react";
import { Pill, Tab, Tabs } from "@monolith-forensics/monolith-ui";

import { Cases } from "./Cases";
import { ETechs } from "./ETechs";
import { Templates } from "./Templates";
import { FprDetails } from "./FprDetails";
import { FprMetrics } from "./FprMetrics";
import ReportParametersPanel, {
  FPR_PARAMS_FIELDS,
} from "../ReportParametersPanel";

import {
  FPR_OBJECT,
  Types,
} from "../../../Settings/Integration/FPR_Integration";

import { getFprReport } from "../../../../api";

import { SavedReports } from "./SavedReports";
import { EditReportPopup } from "../../EditReportPopup";
import Loader from "../../../../components/Loader";
import { Card } from "@mui/material";
import { useQuery } from "@tanstack/react-query";

const TabBadge = ({ count }) => (
  <Pill size="xs" showRemoveIcon={false}>
    {count}
  </Pill>
);

export const FprReport = ({ reportInfo, setFormUpdated }) => {
  const editReportPopup = useRef(null);

  const [mainSelectedTab, setMainSelectedTab] = useState(0);

  const { isLoading, data } = useQuery({
    queryKey: ["fprReport", reportInfo],
    queryFn: () => getFprReport(reportInfo.report_parameters || {}),
  });

  let { evidenceReport: evidencesByFpr, finalReport: casesWithEvidence } =
    data || {};
  if (!evidencesByFpr) evidencesByFpr = FPR_OBJECT;
  if (!casesWithEvidence) casesWithEvidence = [];

  return (
    <div>
      <div
        style={{
          display: "flex",
          marginBottom: "20px",
          userSelect: "text",
        }}
      >
        <FprDetails reportInfo={reportInfo} />
        <ReportParametersPanel
          reportInfo={reportInfo}
          editReportPopup={editReportPopup}
          filterFields={FPR_PARAMS_FIELDS}
        />
        <FprMetrics
          reportInfo={reportInfo}
          cases={casesWithEvidence}
          evidence={evidencesByFpr}
        />
      </div>

      <Tabs value={mainSelectedTab} onChange={setMainSelectedTab}>
        <Tab
          value={0}
          rightSection={<TabBadge count={casesWithEvidence?.length || 0} />}
        >
          Cases
        </Tab>
        <Tab
          value={1}
          rightSection={
            <TabBadge count={evidencesByFpr?.[Types.CPU]?.length || 0} />
          }
        >
          CPUs
        </Tab>
        <Tab
          value={2}
          rightSection={
            <TabBadge count={evidencesByFpr?.[Types.ETECH]?.length || 0} />
          }
        >
          ETech
        </Tab>
        <Tab
          value={3}
          rightSection={
            <TabBadge
              count={evidencesByFpr?.[Types.LOOSE_DRIVES]?.length || 0}
            />
          }
        >
          Loose Drives
        </Tab>
        <Tab
          value={4}
          rightSection={
            <TabBadge
              count={evidencesByFpr?.[Types.STORAGE_MEDIA]?.length || 0}
            />
          }
        >
          Storage Media
        </Tab>
        <Tab
          value={5}
          rightSection={
            <TabBadge count={evidencesByFpr?.[Types.CLOUD]?.length || 0} />
          }
        >
          Cloud
        </Tab>
        <Tab
          value={6}
          rightSection={
            <TabBadge count={evidencesByFpr?.[Types.OTHER]?.length || 0} />
          }
        >
          Other
        </Tab>
      </Tabs>
      <Card style={{ height: 400 }}>
        {isLoading && (
          <div style={{ margin: "15px 0px" }}>
            <Loader />
          </div>
        )}
        {!isLoading && (
          <>
            {mainSelectedTab === 0 && <Cases cases={casesWithEvidence} />}
            {mainSelectedTab === 1 && (
              <Templates evidences={evidencesByFpr[Types.CPU]} />
            )}
            {mainSelectedTab === 2 && (
              <ETechs evidences={evidencesByFpr[Types.ETECH]} />
            )}
            {mainSelectedTab === 3 && (
              <Templates evidences={evidencesByFpr[Types.LOOSE_DRIVES]} />
            )}
            {mainSelectedTab === 4 && (
              <Templates evidences={evidencesByFpr[Types.STORAGE_MEDIA]} />
            )}
            {mainSelectedTab === 5 && (
              <Templates evidences={evidencesByFpr[Types.CLOUD]} />
            )}
            {mainSelectedTab === 6 && (
              <Templates evidences={evidencesByFpr[Types.OTHER]} />
            )}
          </>
        )}
      </Card>

      <div
        style={{
          minHeight: "450px",
          margin: "20px 0px",
        }}
      >
        {/* Decorative single-tab header for visual consistency with the tabbed
            section above; SavedReports always renders below regardless of state. */}
        <Tabs defaultValue={0}>
          <Tab value={0}>Saved Reports</Tab>
        </Tabs>

        <SavedReports reportInfo={reportInfo} />
      </div>

      <EditReportPopup
        editReportPopup={editReportPopup}
        reportInfo={reportInfo}
        setFormUpdated={setFormUpdated}
      />
    </div>
  );
};
